import { ControleAttachmentPreview } from "../shared/components/ControleAttachmentPreview";
import { CHARTER_COLORS as theme } from "../shared/controleTheme";
import { buttonBase } from "../shared/styles/layoutStyles";
import { documentCardStyle } from "../shared/styles/reportStyles";

export function ControleAttachments({ dossierId, attachments, uploading, onUpload, onDelete }) {
    return (
        <section style={documentCardStyle}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                <div>
                    <h2 style={{ margin: 0, color: theme.ink, fontSize: "17px", fontWeight: 950 }}>Documents importés (Approvisionnement des K7 et du MDU)</h2>
                    <div style={{ marginTop: "3px", color: theme.muted, fontSize: "13px" }}>
                        PDF, PNG ou JPEG affichés directement dans la fiche.
                    </div>
                </div>
                <label style={{
                    ...buttonBase,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    background: theme.primary,
                    borderColor: theme.primary,
                    color: "white",
                    fontWeight: 900,
                    cursor: uploading ? "not-allowed" : "pointer",
                    opacity: uploading ? 0.65 : 1,
                }}>
                    {uploading ? "Import..." : "Importer PDF / image"}
                    <input
                        type="file"
                        accept="application/pdf,image/png,image/jpeg"
                        multiple
                        disabled={uploading}
                        onChange={event => {
                            onUpload(event.target.files);
                            event.target.value = "";
                        }}
                        style={{ display: "none" }}
                    />
                </label>
            </div>

            {attachments.length === 0 ? (
                <div style={{
                    padding: "18px",
                    borderRadius: "8px",
                    border: `1px dashed ${theme.borderStrong}`,
                    background: theme.surfaceMuted,
                    color: theme.muted,
                    fontSize: "13px",
                    textAlign: "center",
                }}>
                    Aucun document importé.
                </div>
            ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "12px" }}>
                    {attachments.map(attachment => (
                        <ControleAttachmentPreview
                            key={attachment.id}
                            dossierId={dossierId}
                            attachment={attachment}
                            disabled={uploading}
                            onDelete={onDelete}
                        />
                    ))}
                </div>
            )}
        </section>
    );
}
